
import { ApiChat, ApiMessage } from "../../../api/types";
import React, { FC, memo, useEffect, useState, useRef } from "../../../lib/teact/teact";
import Button from "../../ui/Button";
import SearchInput from "../../ui/SearchInput";
import { GetChatListFromGlobal, GetMessagesByChatId, SendTeleMessage } from "../tdlib/tdlib";
import TeleChatItem from "./teleChatItem";
import TeleMessgeList from "./teleMessgeList";
import './teleChatList.scss'
import { isNull } from "util";
import DropdownMenu from "../../ui/DropdownMenu";
import MenuItem from "../../ui/MenuItem";
import ConfirmDialog from "../../ui/ConfirmDialog";
import Checkbox from "../../ui/Checkbox";
import { addDays, getDateString, getDateStringVN, secondsToDate } from "../utils/DateTimeUtils";
import store from "../store";
import { debounce, getSmsKhopTin, GetUserFullInfo } from "../utils/common";
import { DEBUG } from "../../../config";
import { globalDexieDb } from "../db/DexiedbLib";
import ListItem from "../../ui/ListItem";
import Avatar from "../../common/Avatar";
import { ContactsApi } from "../restapi/contactsApi";
import { IContact } from "../db/model/contact";
import worker from "../setupWorker";
import { ApiResult } from "../db/report/localBackend";

import { sleep } from "../../../lib/gramjs/Helpers";
import { getActions } from "../../../global";
import MyDateInput from "../ui/myDateInput";
import { TeleLocalDb } from "../db/service/telelocaldb";
import { syncTelebotMessages, syncTelebotMessagesWithPayload } from "../tdlib/tdlibemulator";


export type TeleChatDisplayType = 'Chat' | 'ChatDetails'
type OwnProps = {
    displayType: TeleChatDisplayType;
    chatIdToDisplay?: string;
    onTransMessagesFromSelectedToParse: (messages: ApiMessage[]) => void;
    onShowSnackbar: (text: string) => void;
    parentState: any;
}

const TeleChatList: FC<OwnProps> = ({
    displayType,
    onTransMessagesFromSelectedToParse,
    onShowSnackbar,
    parentState,
}) => {
    const { sendMessage } = getActions();
    const userFullinfo = GetUserFullInfo()
    const hiddenChatStorageKey = `teleHiddenChatIds:${userFullinfo.username || "default"}`
    const chatListRef = useRef<HTMLDivElement>(null)
    const headerRef = useRef<HTMLDivElement>(null)
    const gStore = store;
    const workDate = gStore.getState().global.workDate;
    const fromDate = addDays(workDate, -2);
    const toDate = addDays(workDate, -1);
    const [messages, setMessages] = useState();
    const [state, setState] = useState({
        chatList: [] as ApiChat[],
        chatListFull: [] as ApiChat[],
        hiddenChatIds: [] as string[],
        showHiddenChats: false,
        curChat: {} as ApiChat,
        displayType: displayType,
        scrollPosition: 0,
        inSelectChatMode: false,
        selectedChatIds: [] as string[],
        openTransDialog: false,
        inWorkDateOnly: true,
        searchFilter: "",
        showDeleteMessageDialog: false,
        fromDate: fromDate,
        toDate: toDate,
        suDungTinBot: userFullinfo.suDungTinBot == 1,
    })
    function getSavedHiddenChatIds(): string[] {
        try {
            const raw = localStorage.getItem(hiddenChatStorageKey);
            if (!raw) return [];
            const data = JSON.parse(raw);
            return Array.isArray(data) ? data.map(String) : [];
        } catch {
            return [];
        }
    }
    function saveHiddenChatIds(ids: string[]) {
        localStorage.setItem(hiddenChatStorageKey, JSON.stringify(ids));
    }
    function applyChatFilters(chats: ApiChat[], searchFilter: string, showHiddenChats: boolean, hiddenChatIds: string[]): ApiChat[] {
        const val = searchFilter.toLocaleLowerCase();
        const hiddenSet = new Set(hiddenChatIds);
        return chats.filter((chat: ApiChat) => {
            const inSearch = chat.title.toLocaleLowerCase().includes(val);
            if (!inSearch) {
                return false;
            }
            if (showHiddenChats) {
                return hiddenSet.has(chat.id);
            }
            return !hiddenSet.has(chat.id);
        });
    }
    function refreshChatList(chats: ApiChat[], searchFilter: string, showHiddenChats: boolean, hiddenChatIds: string[]) {
        const filtered = applyChatFilters(chats, searchFilter, showHiddenChats, hiddenChatIds);
        setState(prev => ({ ...prev, chatListFull: chats, chatList: filtered }));
    }
    useEffect(() => {
        const hiddenChatIds = getSavedHiddenChatIds();
        setState(prev => ({ ...prev, hiddenChatIds }));
    }, [])
    useEffect(() => {
        let previous = store.getState().wsSlice.messages;
        const unsubscribe = store.subscribe(() => {
            const current = store.getState().wsSlice.messages;
            if (current !== previous) {
                previous = current;
                GetChatListFromGlobal().then(async (result) => {
                    refreshChatList(result, state.searchFilter, state.showHiddenChats, state.hiddenChatIds);
                })
            }
        });

        return unsubscribe;
    }, []);
    useEffect(() => {
        const userFullinfo = GetUserFullInfo()
        if (userFullinfo.suDungTinBot == 1) {
            //worker.postMessage({ type: 'showsnackbar', data: 'Bạn đang sử dụng tin nhắn Bot làm đầu vào tin nhắn. ' })
            syncTelebotMessages()
        }
        GetChatListFromGlobal().then(async (result) => {
            refreshChatList(result, state.searchFilter, state.showHiddenChats, state.hiddenChatIds);
        })

    }, [messages, state.showHiddenChats, state.hiddenChatIds])
    useEffect(() => {
        if (state.curChat) {
            if (state.curChat.id) {
                const div = document.getElementById("chat:" + state.curChat.id);
                if (div) {
                    div.scrollIntoView()
                    //div.scrollTop = state.scrollPosition;
                    //console.log(state.scrollPosition)
                    const container = document.getElementById("content-screen")
                    if (container) {
                        container.scrollTop = state.scrollPosition;
                    }
                }
            }
        }
    }, [state.displayType])
    function handleChatclicked(chat: ApiChat) {
        setState(prev => ({ ...prev, curChat: chat, displayType: "ChatDetails" }))
        const div = document.getElementById(`chat:${chat.id}`);
        if (div) {
            setState(prev => ({ ...prev, scrollPosition: div.offsetTop }))
        }
    }
    function handleOnBack() {
        setState(prev => ({ ...prev, displayType: "Chat" }))
    }
    function handleChangeSelectChatMode(isSelectMode: boolean) {
        setState(prev => ({ ...prev, inSelectChatMode: isSelectMode }))
        if (!isSelectMode) {
            setState(prev => ({ ...prev, selectedChatIds: [] }))
        }
    }
    function handleSelectChat(isSelect: boolean, chat: ApiChat) {
        const chatId = chat.id
        let tmp = state.selectedChatIds;
        if (isSelect) {
            if (!tmp.includes(chatId)) {
                tmp.push(chatId)
            }
        } else {
            tmp = tmp.filter(id => id != chatId)
        }
        let selectMode = tmp.length != 0

        setState(prev => ({ ...prev, selectedChatIds: tmp, inSelectChatMode: selectMode }))

    }
    let lastScrollTop = 0
    function handleChatScroll() {
        if (chatListRef.current) {
            // Kiểm tra hướng cuộn
            if (chatListRef.current.scrollTop > lastScrollTop) {
                if (DEBUG)
                    console.log('Cuộn xuống');
            } else {
                if (DEBUG)
                    console.log('Cuộn lên');
                if (headerRef.current) {
                    headerRef.current.scrollIntoView()
                }
            }
            lastScrollTop = chatListRef.current.scrollTop
        }
    }
    async function handleTransMessagesFromSelectedToParse() {
        const messages: ApiMessage[] = []
        //build ApiMessages to pass
        const promises: Promise<ApiMessage[]>[] = []
        state.selectedChatIds.map(chatId => {
            const promise = new Promise<ApiMessage[]>((resolve, reject) => {
                GetMessagesByChatId(chatId).then(msgs => {
                    messages.push(...msgs)
                    resolve(msgs)
                })
            })
            promises.push(promise)
        })
        await Promise.all(promises)
        if (state.inWorkDateOnly) {
            const msgs = messages.filter(msg => {
                const d = secondsToDate(msg.date)
                const date = getDateString(d)
                return date == store.getState().global.workDate
            })
            onTransMessagesFromSelectedToParse(msgs)
        } else
            onTransMessagesFromSelectedToParse(messages)
    }
    const TransMessagesDialog = (
        <ConfirmDialog
            isOpen={state.openTransDialog}
            confirmLabel="Đồng ý"
            title={`Phân tích tin của ${state.selectedChatIds.length} hội thoại`}
            onClose={() => { setState(prev => ({ ...prev, openTransDialog: false })) }}
            confirmHandler={() => {
                setState(prev => ({ ...prev, openTransDialog: false }))
                handleTransMessagesFromSelectedToParse()
            }}
        >
            <Checkbox label={"Chỉ lấy tin trong ngày do bạn thiết lập " + getDateStringVN(store.getState().global.workDate)}
                onChange={(e) => {
                    setState(prev => ({ ...prev, inWorkDateOnly: e.target.checked }))
                }}
                checked={state.inWorkDateOnly}></Checkbox>
        </ConfirmDialog>
    )
    const debouncedSerchChatList = debounce((value: string) => {
        // Thực hiện các tác vụ tìm kiếm hoặc xử lý dữ liệu với giá trị value
        if (DEBUG)
            console.log("search for:", value)
        const tmp = applyChatFilters(state.chatListFull, value, state.showHiddenChats, state.hiddenChatIds);
        setState(prev => ({ ...prev, chatList: tmp }))
    }, 200);
    function handleHideChats(chatIds: string[], hide: boolean) {
        const hiddenSet = new Set(state.hiddenChatIds);
        if (hide) {
            chatIds.forEach((id) => hiddenSet.add(id));
        } else {
            chatIds.forEach((id) => hiddenSet.delete(id));
        }
        const nextIds = Array.from(hiddenSet);
        saveHiddenChatIds(nextIds);
        const filtered = applyChatFilters(state.chatListFull, state.searchFilter, state.showHiddenChats, nextIds);
        setState(prev => ({ ...prev, hiddenChatIds: nextIds, chatList: filtered }));
        const count = chatIds.length;
        onShowSnackbar(hide
            ? `Đã ẩn ${count} hội thoại`
            : `Đã bỏ ẩn ${count} hội thoại`);
    }
    function confirmDeleteMessage() {
        const chatIds: string[] = []
        if (state.selectedChatIds.length == 0) {
            for (let chat of state.chatListFull) {
                chatIds.push(chat.id)
            }
        } else {
            for (let chatId of state.selectedChatIds) {
                chatIds.push(chatId)
            }
        }
        TeleLocalDb.deleteTelelocalMessages(chatIds, state.fromDate, state.toDate);
        setState(prev => ({ ...prev, showDeleteMessageDialog: false }))
        worker.postMessage({ type: 'showsnackbar', data: 'Đã xoá tin nhắn cục bộ' })
    }
    async function khopSoLuongTin(chatId?: string, selectedChatIds?: string[]) {
        let contactIds = ''
        let selectedChats = state.selectedChatIds
        if (selectedChatIds)
            selectedChats = selectedChatIds;
        if (state.inSelectChatMode || selectedChatIds) {
            for (let chatId of selectedChats) {
                let contact: IContact | undefined = await globalDexieDb.contacts.where('tlUserId').equals(Number(chatId)).first()
                if (contact) {
                    contactIds += contactIds == '' ? contact.contactId : `,${contact.contactId}`
                }
            }
        } else {
            if (chatId) {
                let contact: IContact | undefined = await globalDexieDb.contacts.where('tlUserId').equals(Number(chatId)).first()
                if (contact) {
                    contactIds += contactIds == '' ? contact.contactId : `,${contact.contactId}`
                }
            }
        }
        if (contactIds != '') {
            const payload = { ngay: parentState.workDate, contactIds: contactIds }
            ContactsApi.getContactsListExtraInfoByContactIds(payload).then((result: ApiResult) => {
                //console.log(result)
                getSmsKhopTin(result, parentState.curMien).then(async (smss: Map<string, string>) => {
                    let count = 0;
                    for (let [chatId, sms] of smss) {
                        SendTeleMessage(sms, chatId, sendMessage)
                        await sleep(100)
                        count += 1;
                    }

                    if (count > 0) {
                        const payload = { type: 'showsnackbar', data: `đã gửi tin khớp tới ${count} khách/chủ` }
                        worker.postMessage(payload)
                    }
                })
            })
        }
        else {
            const payload = { type: 'showsnackbar', data: 'Bạn chưa chọn khách để khớp tin hoặc hội thoại chưa cài đặt trong danh bạ' }
            worker.postMessage(payload)
        }
    }
    function handleDongBoTinNhanBot() {

        const globalState = store.getState().global
        const payload = { date: globalState.workDate, lastDate: 0 }
        worker.postMessage({ type: 'showsnackbar', data: 'Đang đồng bộ tin nhắn bot: ' + globalState.workDate })
        syncTelebotMessagesWithPayload(payload)
    }
    ///
    if (state.displayType == 'Chat')
        return (
            <>
                <div className="header" ref={headerRef}>
                    <div className="search">
                        <SearchInput onChange={(e) => {
                            debouncedSerchChatList(e)
                            setState(prev => ({ ...prev, searchFilter: e }))
                        }}
                            value={state.searchFilter}
                        />
                    </div>
                    {state.inSelectChatMode &&
                        <div>
                            đã chọn {state.selectedChatIds.length}
                        </div>
                    }
                    <div className="right-panel">
                        {
                            state.selectedChatIds.length > 0 &&
                            <Button round size="smaller"
                                color={state.inSelectChatMode ? "primary" : "translucent"}
                                onClick={() => {
                                    // const select = !state.inSelectChatMode
                                    // handleChangeSelectChatMode(select)
                                }}
                            >
                                <i className="icon icon-message" />
                            </Button>
                        }
                        <DropdownMenu positionX="right">
                            {
                                state.selectedChatIds.length > 0 &&
                                <>
                                    <MenuItem
                                        onClick={() => {
                                            setState(prev => ({ ...prev, openTransDialog: true }))
                                        }}
                                    >
                                        Phân tích hội thoại đã chọn
                                    </MenuItem>
                                    <MenuItem
                                        onClick={() => {
                                            khopSoLuongTin()
                                        }}
                                    >
                                        Khớp số lượng tin
                                    </MenuItem>
                                </>
                            }
                            {state.selectedChatIds.length == 0 &&
                                <MenuItem
                                    onClick={() => {
                                        const chatIds: string[] = []
                                        for (let chat of state.chatListFull) {
                                            chatIds.push(chat.id)
                                        }
                                        khopSoLuongTin(undefined, chatIds)
                                    }}
                                >
                                    Khớp tin tất cả các khách
                                </MenuItem>
                            }
                            <MenuItem onClick={() => {
                                const select = !state.inSelectChatMode
                                handleChangeSelectChatMode(select)
                            }}
                            >
                                Chọn hội thoại
                            </MenuItem>
                            <MenuItem onClick={() => {
                                const showHidden = !state.showHiddenChats;
                                const filtered = applyChatFilters(state.chatListFull, state.searchFilter, showHidden, state.hiddenChatIds);
                                setState(prev => ({ ...prev, showHiddenChats: showHidden, chatList: filtered }))
                            }}
                            >
                                {state.showHiddenChats ? "✓ Hội thoại ẩn" : "Hội thoại ẩn"}
                            </MenuItem>
                            <MenuItem
                                onClick={() => {
                                    setState(prev => ({ ...prev, showDeleteMessageDialog: true }))

                                }}
                            >
                                Xoá tin nhắn cục bộ
                            </MenuItem>
                            {
                                state.suDungTinBot &&
                                <MenuItem onClick={() => {
                                    const select = !state.inSelectChatMode
                                    handleDongBoTinNhanBot()
                                }}
                                >
                                    Đồng bộ lại tin nhắn bot
                                </MenuItem>
                            }
                        </DropdownMenu>
                    </div>
                </div>
                <div className="telechat-container"
                    onScroll={handleChatScroll}
                    ref={chatListRef}
                >
                    {
                        state.chatList.map(chat => {
                            return chat.title != "" &&
                                <ListItem key={"chat-" + chat.id}
                                    withPortalForMenu
                                    className="chat-item-clickable"

                                    contextActions={[
                                        {
                                            handler: () => {
                                                const select = !state.inSelectChatMode
                                                handleChangeSelectChatMode(select)
                                                if (select)
                                                    handleSelectChat(true, chat)
                                            },
                                            title: "Chọn hội thoại",
                                            icon: "select"
                                        },
                                        {
                                            handler: () => {
                                                khopSoLuongTin(chat.id)
                                            },
                                            title: "Khớp số lượng tin",
                                            icon: "send"
                                        },
                                        {
                                            handler: () => {
                                                const useSelectedChats = state.selectedChatIds.length > 1;
                                                const targetChatIds = useSelectedChats ? state.selectedChatIds : [chat.id];
                                                const hide = !state.showHiddenChats;
                                                handleHideChats(targetChatIds, hide)
                                            },
                                            title: state.showHiddenChats ? "Bỏ ẩn hội thoại" : "Ẩn hội thoại",
                                            icon: "archive"
                                        }
                                    ]
                                    }
                                    onClick={() => {

                                    }}
                                >
                                    <TeleChatItem chat={chat}
                                        onChatClicked={handleChatclicked}
                                        inSelectMode={state.inSelectChatMode}
                                        onChangeSelectChatMode={handleChangeSelectChatMode}
                                        onSelectChat={handleSelectChat}
                                        selected={state.selectedChatIds.includes(chat.id)}
                                    />
                                </ListItem>
                        })
                    }
                </div>
                {TransMessagesDialog}
                <ConfirmDialog onClose={() => { setState(prev => ({ ...prev, showDeleteMessageDialog: false })) }} isOpen={state.showDeleteMessageDialog}
                    confirmHandler={confirmDeleteMessage}
                    title="Xoá tin nhắn cục bộ"
                    confirmLabel="Xoá">
                    <MyDateInput value={state.fromDate} onChange={function (e: React.ChangeEvent<HTMLInputElement>): void {
                        setState(prev => ({ ...prev, fromDate: e.target.value }));

                    }} label={"Từ ngày"} labelPosition={"left"}></MyDateInput>
                    <MyDateInput value={state.toDate} onChange={function (e: React.ChangeEvent<HTMLInputElement>): void {
                        setState(prev => ({ ...prev, toDate: e.target.value }));

                    }} label={"Đến ngày"} labelPosition={"left"}></MyDateInput>
                </ConfirmDialog>
            </>
        )
    else if (state.displayType == 'ChatDetails')
        return <TeleMessgeList
            onShowSnackBar={onShowSnackbar}
            onTransMessagesFromSelectedToParse={onTransMessagesFromSelectedToParse}
            chat={state.curChat} onBack={handleOnBack} />
}


export default memo(TeleChatList)